var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.405,
    height: 38.405,
    viewBox: "0 0 38.405 38.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M5367.9,3179.5a19.2,19.2,0,1,0,19.2,19.2A19.2,19.2,0,0,0,5367.9,3179.5Zm10.248,14.21V3204.2a2.878,2.878,0,0,1-2.873,2.877h-14.745a2.881,2.881,0,0,1-2.876-2.877v-11a2.881,2.881,0,0,1,2.876-2.876h14.745a2.872,2.872,0,0,1,2.835,2.448,2.47,2.47,0,0,1,.037.429Z",
    transform: "translate(-5348.694 -3179.5)",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M5383.873,3223.552a1.013,1.013,0,0,1-.584-.184l-7.673-5.368v8.972a.832.832,0,0,0,.834.833h14.745a.831.831,0,0,0,.829-.833v-8.9l-7.562,5.3A1.017,1.017,0,0,1,5383.873,3223.552Z",
    transform: "translate(-5364.615 -3202.271)",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M5392.1,3211.491a.832.832,0,0,0-.757-.491H5376.6a.823.823,0,0,0-.731.438l8.155,5.707Z",
    transform: "translate(-5364.764 -3198.13)",
    fill: "#f77f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon1);
export default __webpack_public_path__ + "static/media/email-icon1.56c628827f7a0767d10fae5b0e264b73.svg";
export { ForwardRef as ReactComponent };